"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokens = exports.colors = void 0;
const CodeColors_1 = require("code-colors/lib/CodeColors");
const bundle = "https://unpkg.com/code-colors@2.2.0/dist/bundle.js";
let __colors = null;
const colors = () => {
    if (!__colors)
        __colors = new CodeColors_1.CodeColors(bundle);
    return __colors;
};
exports.colors = colors;
const tokens = async (code, lang) => {
    // await new Promise(r => setTimeout(r, 1000));
    return await (0, exports.colors)().tokenize(code, lang);
};
exports.tokens = tokens;
